import { DateRange, Delete, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Divider, Grid, IconButton, InputAdornment, List, ListItem, ListItemSecondaryAction, ListItemText, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import $carbon, { animalsMassAndNexcretion, pesticideTypes } from "../../../services/$carbon";
import SelectInput from "../../ui/SelectInput";
import { variables } from "../../../styles/abstract/variables";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

function FertilizersForm(props) {
  const { model, setModel, nextStep, prevStep, climateZone, year, area } = props;

  const [local, setLocal] = useState({
    product: undefined,

    amount: undefined,
    percentageN: 0,
    percentageU: 0,
    percentageL: 0,
  });


  useEffect(() => {
    if (model.records.length > 0) {
      let total = $carbon.calculateFertiliserEmission(model.records, climateZone, area);
      console.log(total);
      setModel({ totalEmission: total });
    } else {
      setModel({ totalEmission: undefined });
    }
  }, [JSON.stringify(model.records)]);

  const renderRecords = () => {
    if (model.records.length === 0) {
      return (
        <Grid item xs={12}>
          <Typography>No records</Typography>
        </Grid>
      )
    }

    return (
      <Grid item xs={12}>
        <List dense>
          {
            model.records.map((record, i) => (
              <ListItem className="co-background" key={i}>
                <ListItemText primary={record.product} secondary={`Amount (kg/ha): ${record.amount} | Nitrogen(%): ${record.percentageN} | Urea(%): ${record.percentageU} | Limestone(%): ${record.percentageL}`} />
                <ListItemSecondaryAction><IconButton onClick={() => setModel({records: model.records.filter((r,j) => j !== i)})} size="small" color="error"><Delete fontSize="small"/></IconButton></ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </List>
      </Grid>
    )

  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <MobileDatePicker
                    format="YYYY-MM-DD"
                    minDate={moment(`${year}-01-01`)}
                    maxDate={moment(`${year}-12-31`)}
                    slotProps={{
                      textField: {
                        label: 'Date',
                        variant: 'outlined',
                        fullWidth: true,
                        size: 'small',
                        InputProps: { endAdornment: <InputAdornment position="end" sx={{ cursor: 'pointer', mb: '3px' }}><DateRange fontSize="small" /></InputAdornment> }
                      }
                    }}
                    value={local.date}
                    onChange={(newValue) => setLocal(current => ({...current, date: newValue.format('YYYY-MM-DD')}))} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectInput name="Product" value={local.product} items={$carbon.formatProducts(climateZone)} onChange={(e) => { setLocal(current => ({ ...current, product: e.target.value })) }} label="Product" variant="outlined" fullWidth size="small" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size="small" value={local.amount} onChange={(e) => setLocal(current => ({ ...current, amount: e.target.value }))} type="number" label="Amount of product (kg/ha)" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12}>
                <Stack>
                  <span>Nitrogen percentage in product (%)</span>
                  <Slider value={local.percentageN} min={0} max={100} valueLabelDisplay="auto" onChange={(evt, val) => setLocal(current => ({...current, percentageN: val }))} />
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack>
                  <span>Urea percentage in product (%) (if applicable)</span>
                  <Slider value={local.percentageU} min={0} max={100} valueLabelDisplay="auto" onChange={(evt, val) => setLocal(current => ({...current, percentageU: val }))} />
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack>
                  <span>Limestone percentage in product (%) (if applicable)</span>
                  <Slider value={local.percentageL} min={0} max={100} valueLabelDisplay="auto" onChange={(evt, val) => setLocal(current => ({...current, percentageL: val }))} />
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button disabled={!local.product || !local.amount || (local.percentageN === 0 && local.percentageL === 0 && local.percentageU === 0)} onClick={() => setModel({ records: [...model.records, { ...local }] })} variant="contained" >Add record</Button>
              </Grid>

              <Grid item xs={12}>
                <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
              </Grid>
              {renderRecords()}
            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} variant="contained" endIcon={<KeyboardArrowRight />}>Next</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default FertilizersForm;